export const PointerRadiusDistance = 4